var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTileView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7805",
    "data-name": "Rectangle 7805",
    width: 29,
    height: 29,
    transform: "translate(15104 -15740)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grid_view",
    "data-name": "Grid view",
    transform: "translate(-15104 15740)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30861",
    "data-name": "Group 30861",
    transform: "translate(13911 -15765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30859",
    "data-name": "Group 30859",
    transform: "translate(1196 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22723",
    "data-name": "Path 22723",
    d: "M330.225,184.279h-7.117a1.7,1.7,0,0,1-1.695-1.695V172.553a1.7,1.7,0,0,1,1.695-1.7h7.117a1.7,1.7,0,0,1,1.7,1.7v10.031A1.7,1.7,0,0,1,330.225,184.279Zm0-23.839h-7.117a1.7,1.7,0,0,0-1.695,1.695v5.174a1.7,1.7,0,0,0,1.695,1.7h7.117a1.7,1.7,0,0,0,1.7-1.7v-5.174A1.7,1.7,0,0,0,330.225,160.44Zm-19.61.265h7.117a1.7,1.7,0,0,1,1.7,1.7v19.919a1.7,1.7,0,0,1-1.7,1.695h-7.117a1.7,1.7,0,0,1-1.7-1.695V162.4A1.7,1.7,0,0,1,310.615,160.7Z",
    transform: "translate(-308.92 -160.44)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileView);
export default __webpack_public_path__ + "static/media/tileView.65201eef9f273c6ec46db8e6edc9fe40.svg";
export { ForwardRef as ReactComponent };